import { render } from "./CampaignsDetailSegments.vue?vue&type=template&id=1b8eed58&scoped=true"
import script from "./CampaignsDetailSegments.vue?vue&type=script&lang=js"
export * from "./CampaignsDetailSegments.vue?vue&type=script&lang=js"

import "./CampaignsDetailSegments.vue?vue&type=style&index=0&id=1b8eed58&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8eed58"]])

export default __exports__